import { DateTime } from 'luxon';
import axios from 'axios';
import Chat from './live-agent';

export class CoordinateOpenHours {
    constructor() {
        this.now = this.localDate();
        this.currentTime = this.getCurrentTime();
        this.init();
    }

    async init() {
        this.serviceData = await this.getServiceData();
        this.initChat();
        // console.log('________');
        this.initClosedMessages();
        this.initTodaysOpeningHours();
    }

    async getServiceData() {
        try {
            const data = await axios.get(`/marketing-api/locations.json`);
            return data;
        } catch (err) {
            console.error(err);
        }
    }

    initChat() {
        this.serviceData.data.locations.find(({ services }) => {
            const service = services.find(({ usedForliveAgentChat }) => usedForliveAgentChat);
            if (service) {
                new Chat(this.checkIfOpen(service));
                return service;
            }
        });
    }

    initTodaysOpeningHours() {
        // Used in header 'contact' foldout
        const els = Array.from(document.querySelectorAll('.js-todays-opening-hours'));
        els.forEach((el) => {
            const service = this.findService({ serviceId: el.dataset.serviceId });

            if (service) {
                const todayTimes = service.openingHoursByDayReadable.find((block) =>
                    block.days.includes(this.now.weekdayLong)
                );
                const holiday = this.getCurrentHoliday(service);
                if (holiday) {
                    console.log('Holiday', holiday.openingHoursReadable);
                    el.innerHTML = `Today: ${holiday.openingHoursReadable}`;
                } else {
                    el.innerHTML = `Today: ${todayTimes.times}`;
                }
            }
        });
    }

    findService({ serviceId, serviceName }) {
        let service;
        this.serviceData.data.locations.find(({ services }) => {
            service = services.find(({ id, name }) => id == serviceId || name === serviceName);
            return service;
        });
        return service;
    }

    initClosedMessages() {
        // Used on conteact pages to indicate phone contact is not available.
        const service = this.findService({ serviceName: 'Member Care' });
        if (service && !this.checkIfOpen(service)) {
            const closedMessage = document.querySelector('.js-closed-message');
            if (closedMessage) {
                closedMessage.classList.add('toggled');
            }
        }
    }

    checkIfOpen(service) {
        const currentHoliday = this.getCurrentHoliday(service);
        const currentWeekday = this.now.weekdayLong.toLowerCase();
        let opening = service.openingHours[`${currentWeekday}Opening`];
        let closing = service.openingHours[`${currentWeekday}Closing`];
        // console.log('currentHoliday', currentHoliday);
        // console.log('opening', opening);
        // console.log('closing', closing);
        if (currentHoliday) {
            opening = currentHoliday.open;
            closing = currentHoliday.close;
        }
        // console.log('opening', opening);
        // console.log('closing', closing);
        // console.log('currentTime', this.currentTime);
        return this.currentTime >= opening && this.currentTime <= closing;
    }

    getCurrentHoliday(service) {
        return service.openingHoursExceptions.find((block) => {
            // console.log(block);
            if (block.endDate && block.endDate !== block.startDate) {
                // Check if within date range (inclusive)
                const start = this.localDate(block.startDate).startOf('day');
                const end = this.localDate(block.endDate).startOf('day');
                const currentDay = this.now.startOf('day');
                console.log(
                    'range',
                    start.toFormat('dd-MM-yyyy HH:mm:ss'),
                    end.toFormat('dd-MM-yyyy HH:mm:ss'),
                    this.now.startOf('day').toFormat('dd-MM-yyyy HH:mm:ss'),
                    this.now.toFormat('dd-MM-yyyy HH:mm:ss'),
                    currentDay >= start && currentDay <= end
                );
                return currentDay >= start && currentDay <= end;
            } else {
                console.log('single day holiday', this.now.toFormat('dd-MM') == block.startDate);
                return block.startDate === this.now.toFormat('dd-MM'); // Single day holiday
            }
        });
    }

    getCurrentTime() {
        const currentHour = parseInt(this.now.toFormat('H'));
        const currentMinute = parseInt(this.now.toFormat('m')) / 60; // 2.30pm = 14.5 (Hp API requirement...)
        // console.log('currentHour', currentHour);
        // console.log('currentMinute', currentMinute);
        return parseFloat(`${currentHour + currentMinute}`);
    }

    localDate(ddMM) {
        if (ddMM) {
            return DateTime.fromFormat(ddMM, 'dd-MM').setZone('Australia/Adelaide');
        }
        return DateTime.now().setZone('Australia/Adelaide');
    }
}

export default new CoordinateOpenHours();
